import axios from 'axios';
import axiosRetry from 'axios-retry';

axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay });

const axiosOptions = {
  // baseURL: 'http://localhost:8000/api/',
  baseURL: 'https://www.profscomputers.nl/api/',
  withCredentials: true,
  timeout: 15000,
};

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

const apiAxios = axios.create(axiosOptions);

apiAxios.interceptors.request.use((config) => {
  const configuration = config;
  // add _format=json to every request
  configuration.params = {
    ...{ _format: 'json' },
    ...(config.method === 'get' && { ts: Date.now().toString() }),
    ...config.params,
  };

  const XSRFTokenFromCookie = getCookie('XSRF-TOKEN');

  if(XSRFTokenFromCookie) {
    configuration.headers['X-XSRF-TOKEN'] = decodeURIComponent(XSRFTokenFromCookie);
  }

  return configuration;
});

const getXSRFToken = () => apiAxios.get('csrf-cookie');

const requestWithXSRFToken =
  (method) =>
  (...args) =>
    getXSRFToken().then(() => apiAxios[method](...args));

const api = {
  ...apiAxios,
  ...{
    post: requestWithXSRFToken('post'),
    patch: requestWithXSRFToken('patch'),
    put: requestWithXSRFToken('put'),
    delete: requestWithXSRFToken('delete'),
  },
};

const listeners = [];
export const addListener = (listener) => listeners.push(listener);

export default Object.keys(api).reduce(
  (result, method) => ({
    ...result,
    [method]: (...args) => {
      const promise = api[method](...args);
      listeners.forEach((listener) => listener(promise));
      return promise;
    },
  }),
  {}
);
